import { Skeleton } from 'antd';
import { Carousel } from 'react-carousel-minimal';
import Wrapper from './style';

function App(props) {
  const {
    imagesData = [],
    style,
    width = '850px',
    height = '260px',
    loading,
  } = props;

  if (!loading && imagesData?.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            padding: '0',
          }}
        >
          {loading && (
            <Skeleton.Button
              active
              className="component_skeleton_image"
              style={{
                textAlign: 'center',
                maxWidth: '850px',
                maxHeight: '500px',
                margin: '40px auto',
                height,
                borderRadius: '8px',
                ...style,
              }}
              block
            />
          )}
          {!loading && (
            <Carousel
              data={imagesData}
              time={2000}
              width={width}
              height={height}
              radius="8px"
              captionPosition="bottom"
              slideBackgroundColor="darkgrey"
              slideImageFit="cover"
              thumbnails={imagesData.length > 1}
              thumbnailWidth="100px"
              showNavBtn={imagesData?.length > 1}
              style={{
                textAlign: 'center',
                maxWidth: '850px',
                maxHeight: '500px',
                margin: '40px auto',
                ...style,
              }}
            />
          )}
        </div>
      </div>
    </Wrapper>
  );
}

export default App;
